import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { Colligate } from "../types";

export const DELETE_QUERY = print(gql`
  mutation DeleteTeachingAreaConversion($deleteTeachingAreaConversionId: Int!) {
    deleteTeachingAreaConversion(id: $deleteTeachingAreaConversionId) {
      id
      colligate {
        id
        databaseName
        description
        active
        partnerVisibleName
        createdAt
        updatedAt
      }
      idColligate
      databaseName
      idArea
      teachingAreaName
      createdAt
      updatedAt
    }
  }
`);

export interface DeleteGql {
  deleteTeachingAreaConversion: {
    id: number;
    colligate: Colligate;
    databaseName: string;
    idColligate: number;
    idArea: string;
    teachingAreaName: string;
    createdAt: Date;
    updatedAt: Date;
  };
}
